import Vue from 'vue'
import Vuex from 'vuex'
import {API_URL} from '@/utils/url'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hotCareerCount: 0,
   
    isShowLoginBox: false,//登录框的显示和隐藏
    //是否隐藏topbar中未登录盒子
    isShowTopBarNoLoginBox: localStorage.getItem("user-token") ? false : true,
    //
    isShowDefaultLogin: true,//展示登录还是注册
    // //用户id
    userId:  localStorage.getItem("user-id") ,
      //用户图片
    userImg:  API_URL+localStorage.getItem("user-img"), 
    userName:localStorage.getItem("user-nickname"),
    //
    redirectUrl: '',
    userFillState:localStorage.getItem("user-fillState"), //用于判断是否显示欢迎页
    message:'',
    msgSum:0, //消息数量

    isServerReconnection:true,//是否断开重新连接websocket服务器
    isShowLoginExpiredBox: true,//是否显示登录已失效弹窗
    webSocket:null,//websocket实例

  },
  getters: {
  },
  mutations: {
    changeMsgSum(state, val) {
      state.msgSum = val
    },
    changeMessage(state, val) {
      state.message = val
    },
    changeUserId(state, val) {
      state.userId = val
    },
    changeHotCareerCount(state, val) {
      state.hotCareerCount = val
    },
    changeLoginBox(state, val) {
      state.isShowLoginBox = val
    },
    changeTopBarNoLoginBox(state, val) {
      state.isShowTopBarNoLoginBox = val
    },
    changeDefaultLoginState(state, val) {
      state.isShowDefaultLogin = val
    }
  },
  actions: {
  },
  modules: {
  }
})
